// src/context/api.js
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const baseUrl = "https://live-quiz-backend-two.vercel.app/api";
// const baseUrl = "http://localhost:5000/api";

export const api = createApi({
  reducerPath: "api",
  baseQuery: fetchBaseQuery({
    baseUrl,
    prepareHeaders: (headers) => {
      // ✅ sening storage: livequiz_auth
      const raw = localStorage.getItem("livequiz_auth");
      if (raw) {
        try {
          const parsed = JSON.parse(raw);
          const token = parsed?.token;
          if (token) headers.set("authorization", `Bearer ${token}`);
        } catch (e) {
          // json buzilgan bo'lsa ignore
        }
      }
      return headers;
    },
  }),
  tagTypes: ["Test", "User", "Question", "Textbook","Test", "TestPdf"],
  endpoints: () => ({}),
});
